module.exports = __webpack_public_path__ + "img/yixiugai.89d5fe0c.png";